import { useState } from 'react';
import Select from 'common/components/form/inputs/Select';
import StyledSelect from 'common/components/form/styled-inputs/Select';
import { getAsyncOptions, getInitialAsyncValues } from 'utils/helpers';
import useFilterSelector from 'common/components/filters/useFilterSelector';

const OrganizationsSelector = ({ filter, onChange, isMulti, styled, ...rest }) => {
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);

  useFilterSelector(
    filter?.value,
    { list: 'organizations' },
    { selected: selectedOrganizations, setSelected: setSelectedOrganizations }
  );

  const SelectTag = styled ? StyledSelect : Select;

  return (
    <SelectTag
      autoFocus
      placeholder="Select value"
      className="mb-0"
      getOptionValue={option => option.id}
      getOptionLabel={option => option.name}
      size="sm"
      value={
        isMulti
          ? filter.value?.length
            ? selectedOrganizations.filter(el =>
                (isMulti ? filter.value : [filter.value]).map(Number).includes(el.id)
              )
            : []
          : filter.value
      }
      isMulti={isMulti}
      isAsync
      defaultOptions={() => getInitialAsyncValues('organizations')}
      loadOptions={search => getAsyncOptions(search, 'organizations')}
      onChange={selected => {
        setSelectedOrganizations(isMulti ? selected : [selected]);
        onChange({
          value: selected ? (isMulti ? [...selected.map(s => s.id)] : selected) : ''
        });
      }}
      {...rest}
    />
  );
};

export default OrganizationsSelector;
